import axios from 'axios'
var MfaSession = {};
var _baseURL = process.env.VUE_APP_AUTH_API + '/user_mfa_sessions';

MfaSession.install = function(Vue) {
  Vue.prototype.$mfaSession = {
    create(data, callback, errorCallback) {
      axios({
        method: 'POST',
        url: _baseURL,
        data,
        withCredentials: true,
      }).then(
        callback, (error) => errorCallback(error.response)
      )
    },
    getQrCode(callback, errorCallback) {
      axios({
        method: 'GET',
        url: _baseURL + '/qr_code',
        withCredentials: true,
      }).then(
        callback, errorCallback
      )
    },
    enable2fa(code, callback, errorCallback) {
      axios({
        method: 'POST',
        url: _baseURL + '/enable_2fa',
        data: { code },
        withCredentials: true,
      }).then(
        callback, errorCallback
      )
    },
    getRecoveryCodes(callback, errorCallback) {
      axios({
        method: 'GET',
        url: _baseURL + '/recovery_codes',
        withCredentials: true,
      }).then(
        callback, errorCallback
      )
    },
    generateRecoveryCodes(callback, errorCallback) {
      axios({
        method: 'POST',
        url: _baseURL + '/generate_recovery_codes',
        withCredentials: true,
      }).then(
        callback, errorCallback
      )
    },
  }
}

export { MfaSession as default };
